module.exports = __webpack_public_path__ + "img/direction-left.1c5e75dd.svg";